import { animate, group, state, style, transition, trigger } from '@angular/animations';

export enum NOTIFICATION_POSITION {
	FIXED = 'fixed-'
}

export enum ANIMATIONS {
	IN = 'in',
	TOP = 'top',
	BOTTOM = 'bottom',
	RIGHT = 'right',
	LEFT = 'left',
	TOP_LEFT = 'top-left',
	CENTER_LEFT = 'center-left',
	BOTTOM_LEFT = 'bottom-left',
	TOP_CENTER = 'top-center',
	CENTER_CENTER = 'center-center',
	BOTTOM_CENTER = 'bottom-center',
	TOP_RIGHT = 'top-right',
	CENTER_RIGHT = 'center-right',
	BOTTOM_RIGHT = 'bottom-right',
}

export enum ANIMATION_STATE {
	IN = '-in',
	OUT = '-out'
}

export const ANIMATION = [
	trigger('animation', [
		state(
			`${ANIMATIONS.TOP}${ANIMATION_STATE.IN},
			${ANIMATIONS.BOTTOM}${ANIMATION_STATE.IN},
			${ANIMATIONS.LEFT}${ANIMATION_STATE.IN},
			${ANIMATIONS.RIGHT}${ANIMATION_STATE.IN}`,
			style({
				'top': '0', 'opacity': '1', 'visibility': 'visible'
			})
		),
		// Position relative States
		state(`${ANIMATIONS.TOP}${ANIMATION_STATE.OUT}`, style({
			'top': '-1000px', 'opacity': '0', 'visibility': 'hidden'
		})),
		state(`${ANIMATIONS.BOTTOM}${ANIMATION_STATE.OUT}`, style({
			'top': '1000px', 'opacity': '0', 'visibility': 'hidden'
		})),
		state(`${ANIMATIONS.RIGHT}${ANIMATION_STATE.OUT}`, style({
			'right': '-1000px', 'opacity': '0', 'visibility': 'hidden'
		})),
		state(`${ANIMATIONS.LEFT}${ANIMATION_STATE.OUT}`, style({
			'left': '-1000px', 'opacity': '0', 'visibility': 'hidden'
		})),
		// Position fixed States
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_LEFT}${ANIMATION_STATE.IN}`, style({
			'top': '0', 'left': '0', 'opacity': '1', 'visibility': 'visible'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_LEFT}${ANIMATION_STATE.OUT}`, style({
			'top': '0', 'left': '-20%', 'opacity': '0', 'visibility': 'hidden'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_LEFT}${ANIMATION_STATE.IN}`, style({
			'top': '50%', 'left': '0', 'opacity': '1', 'visibility': 'visible', 'transform': 'translateY(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_LEFT}${ANIMATION_STATE.OUT}`, style({
			'top': '50%', 'left': '-20%', 'opacity': '0', 'visibility': 'hidden', 'transform': 'translateY(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_LEFT}${ANIMATION_STATE.IN}`, style({
			'bottom': '0', 'left': '0', 'opacity': '1', 'visibility': 'visible'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_LEFT}${ANIMATION_STATE.OUT}`, style({
			'bottom': '0', 'left': '-20%', 'opacity': '0', 'visibility': 'hidden'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_CENTER}${ANIMATION_STATE.IN}`, style({
			'top': '0', 'left': '50%', 'opacity': '1', 'visibility': 'visible', 'transform': 'translateX(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_CENTER}${ANIMATION_STATE.OUT}`, style({
			'top': '-20%', 'left': '50%', 'opacity': '0', 'visibility': 'hidden', 'transform': 'translateX(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_CENTER}${ANIMATION_STATE.IN}`, style({
			'top': '50%', 'left': '50%', 'opacity': '1', 'visibility': 'visible', 'transform': 'translate(-50%, -50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_CENTER}${ANIMATION_STATE.OUT}`, style({
			'top': '-20%', 'left': '50%', 'opacity': '0', 'visibility': 'hidden', 'transform': 'translateX(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_CENTER}${ANIMATION_STATE.IN}`, style({
			'bottom': '0', 'left': '50%', 'opacity': '1', 'visibility': 'visible', 'transform': 'translateX(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_CENTER}${ANIMATION_STATE.OUT}`, style({
			'bottom': '-20%', 'left': '50%', 'opacity': '0', 'visibility': 'hidden', 'transform': 'translateX(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_RIGHT}${ANIMATION_STATE.IN}`, style({
			'top': '0', 'right': '0', 'opacity': '1', 'visibility': 'visible'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_RIGHT}${ANIMATION_STATE.OUT}`, style({
			'top': '0', 'right': '-20%', 'opacity': '0', 'visibility': 'hidden'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_RIGHT}${ANIMATION_STATE.IN}`, style({
			'top': '50%', 'right': '0', 'opacity': '1', 'visibility': 'visible', 'transform': 'translateY(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_RIGHT}${ANIMATION_STATE.OUT}`, style({
			'top': '50%', 'right': '-20%', 'opacity': '0', 'visibility': 'hidden', 'transform': 'translateY(-50%)'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_RIGHT}${ANIMATION_STATE.IN}`, style({
			'bottom': '0', 'right': '0', 'opacity': '1', 'visibility': 'visible'
		})),
		state(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_RIGHT}${ANIMATION_STATE.OUT}`, style({
			'bottom': '0', 'right': '-20%', 'opacity': '0', 'visibility': 'hidden'
		})),
		// Animations for position relative
		transition(`${ANIMATIONS.TOP}${ANIMATION_STATE.IN} => ${ANIMATIONS.TOP}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'top': '-1000px'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${ANIMATIONS.TOP}${ANIMATION_STATE.OUT} => ${ANIMATIONS.TOP}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'top': '0px'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${ANIMATIONS.BOTTOM}${ANIMATION_STATE.IN} => ${ANIMATIONS.BOTTOM}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'top': '1000px'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${ANIMATIONS.BOTTOM}${ANIMATION_STATE.OUT} => ${ANIMATIONS.BOTTOM}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'top': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${ANIMATIONS.RIGHT}${ANIMATION_STATE.IN} => ${ANIMATIONS.RIGHT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'right': '-1000px'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${ANIMATIONS.RIGHT}${ANIMATION_STATE.OUT} => ${ANIMATIONS.RIGHT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'right': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${ANIMATIONS.LEFT}${ANIMATION_STATE.IN} => ${ANIMATIONS.LEFT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'left': '-1000px'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${ANIMATIONS.LEFT}${ANIMATION_STATE.OUT} => ${ANIMATIONS.LEFT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'left': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		// Animations for position Fixed
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_LEFT}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_LEFT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'left': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_LEFT}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_LEFT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'left': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_LEFT}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_LEFT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'left': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_LEFT}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_LEFT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'left': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_LEFT}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_LEFT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'left': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_LEFT}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_LEFT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'left': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_CENTER}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_CENTER}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'top': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_CENTER}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_CENTER}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'top': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_CENTER}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_CENTER}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'top': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_CENTER}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_CENTER}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'top': '50%',
					'transform': 'translate(-50%, -50%)'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_CENTER}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_CENTER}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'bottom': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_CENTER}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_CENTER}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'bottom': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_RIGHT}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_RIGHT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'right': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_RIGHT}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.TOP_RIGHT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'right': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_RIGHT}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_RIGHT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'right': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_RIGHT}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.CENTER_RIGHT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'right': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_RIGHT}${ANIMATION_STATE.IN} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_RIGHT}${ANIMATION_STATE.OUT}`, [
			group([
				animate('400ms ease-in-out', style({
					'opacity': '0'
				})),
				animate('600ms ease-in-out', style({
					'right': '-20%'
				})),
				animate('800ms ease-in-out', style({
					'visibility': 'hidden'
				}))
			])
		]),
		transition(`${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_RIGHT}${ANIMATION_STATE.OUT} => ${NOTIFICATION_POSITION.FIXED}${ANIMATIONS.BOTTOM_RIGHT}${ANIMATION_STATE.IN}`, [
			group([
				animate('1ms ease-in-out', style({
					'visibility': 'visible'
				})),
				animate('600ms ease-in-out', style({
					'right': '0'
				})),
				animate('800ms ease-in-out', style({
					'opacity': '1'
				}))
			])
		]),
	])
];